import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useInput } from 'react-admin';
import throttle from 'lodash/throttle';
import {useForm} from "react-final-form";

const StreetAutoCompleteInputCustom = props => {
    const [valueNew, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState('');
    const [defaultData, setDefaultData] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const [isChanged, setIsChanged] = React.useState(false);
    const form = useForm();
    let isTouched = false;

    const {
        input: { name, onChange, value },
        meta: { touched, error },
        isRequired
    } = useInput(props);

    const fetch_settlements =
            throttle((request, callback) => {
                let settlement = form.getState().values?.residenceAddress?.settlementId || form.getState().values?.settlementId;
                let streetType = form.getState().values?.residenceAddress?.streetType || form.getState().values?.streetType;

                if (!settlement) {
                    return;
                }

                fetch(
                    process.env.REACT_APP_BASE_ENTRYPOINT +
                    '/address/street?page_size=1000&settlement_id=' + settlement  + '&type=' + streetType + '&name=' + request,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'x-session': localStorage.getItem('session')
                        }
                    }
                ).then(response => response.json()).then(callback);
            }, 600);

    const getOptionsOnfocus = () => {
        fetch_settlements("", (results) => {
            if (results.data?.length) {
                setOptions(sortingData(results.data));
            } else {
                setOptions([]);
            }
        });
    }

    const sortingData = (data) => {
        return data.sort((a,b) => a.name.localeCompare(b.name));
    }

    React.useEffect(() => {
        fetch_settlements(value, (results) => {
            if (results.data?.length) {
                let data = sortingData(results.data);

                setDefaultData(data.find(item => item.name == value));
                setOptions(data);
            } else {
                let item = {name: value, id: value};

                setDefaultData(item);
                setOptions([item]);
            }
        })
    }, [value, inputValue]);

    return (
        <>
            <Autocomplete
                freeSolo
                resettable
                name={name}
                label={props.label}
                required={isRequired}
                filterOptions={(x) => x}
                getOptionLabel={(option) => (option.name)}
                getOptionSelected={(option) => option.name == value}
                defaultValue={defaultData}
                inputValue={defaultData?.name || ""}
                options={options}
                onBlur={() => isTouched = true}
                noOptionsText="Оберіть область, потім населений пункт та тип вулиці"
                onFocus={(event) => {
                    //getOptionsOnfocus();
                }}
                onChange={(event, newValue) => {
                    setIsChanged(true);
                    setOptions(newValue ? [newValue, ...options] : options);
                    setValue(newValue);
                    onChange(newValue?.name);
                }}
                onInputChange={(event, newInputValue) => {
                    onChange(newInputValue);
                    setInputValue(newInputValue);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="filled"
                        label="Назва вулиці"
                        error={!!(isTouched && error)}
                        helperText={<span>&#8203;{error}</span>}
                        required={isRequired}
                        placeholder="Оберіть вулицю"
                        // InputProps={{
                        //     ...params.InputProps,
                        //     type: 'search'
                        // }}
                    />
               )}
            />
        </>
    );
};

export default StreetAutoCompleteInputCustom;
